import { AxiosResponse } from "axios";
import api from "utils/api";
import { Erorr } from "../../types/auth";

export async function postServices(url: string,body:any,token?:string|null,navigate?:any) {
    try {
      const response: AxiosResponse = await api.post(url,body, {
        headers: {
        'Content-Type': 'application/json', 
          "Authorization": `Bearer ${token}`
        }
      });
  
      if (!response.data.success) {
        throw new Error('Məlumatların axtarışı uğurlu alınmadı.');
      }
      const Erorr = {
        statusCode: response.status,
        message: response.data.message || '',
      };

  return Erorr as Erorr;
  
    } catch (error :any) {
    
   
     
            const Erorr = {
            statusCode: error.response.status||0,
            message: error.response.data.message || '',
          };
         
      return Erorr as Erorr;
    }
  }